export const CLIENT_PERSON_TYPE = 'person';
export const CLIENT_COMPANY_TYPE = 'company';